<template>
	<div class="brand-wall" @scroll.passive="handleScroll">
		<div class="navbar-white">
			<Navbar
				class="desktop-center"
				:logoSrc="$logoSrc"
				:backButton="false"
			/>
		</div>
		<Banner class="brand-banner" :showSubtitle="false" />
		<HorizontalNavbar
			ref="brandNavbar"
			class="brand-navbar desktop-center"
			:isSticky="navbarSticky"
			:stickyEnabled="navbarSticky"
			:options="brandNavbarOptions"
			:stickyOffset="0"
			@optionSelected="brandSelected"
		/>
		<div class="brand-wall-content desktop-center">
			<div class="brands-list">
				<BrandCard
					v-for="brand in brandsAboveTheFold"
					:key="brand.id"
					:brand="brand"
				/>
			</div>
			<div class="sk-widget-alt brands-disclaimer-banner">
				<div>
					<h3>Satisfy all your cravings at once!</h3>
					<div>Add items from any brand menus to your order</div>
					<div>Everything will arrive together</div>
				</div>
			</div>
			<div class="brands-list">
				<BrandCard
					v-for="brand in brandsBelowTheFold"
					:key="brand.id"
					:brand="brand"
				/>
			</div>
		</div>
	</div>
</template>

<style scoped>
.brand-banner {
	margin-bottom: 0;
}

.brand-navbar >>> .option-nav {
	margin-left: 0px;
	margin-right: 0px;
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
}

@media only screen and (max-width: 650px) {
	.brand-navbar >>> .option-nav {
		margin-left: -2px;
		margin-right: -2px;
		border-bottom-left-radius: 5px;
		border-bottom-right-radius: 5px;
	}
}

@media only screen and (max-width: 1000px) {
	.brand-banner {
		margin-left: -2px;
		margin-right: -2px;
	}
}

@media only screen and (max-width: 650px) {
	.brand-banner >>> .option-nav {
		margin-left: -16px;
		margin-right: -16px;
	}
}

.brand-navbar {
	height: 50px !important;
}

.brand-wall {
	margin-bottom: 10px;
	height: 100%;
	overflow: scroll;
}

.brands-list {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-column-gap: 10px;
	grid-row-gap: 10px;
	margin: 10px 0;
}

.brands-disclaimer-banner {
	background: var(--gR-base-80);
	margin: 10px 0;
	width: auto;
}

.brands-disclaimer-banner h3 {
	font-size: 16px;
	font-weight: var(--sk-font-bold);
}

.brands-disclaimer-banner h3,
.brands-disclaimer-banner div {
	color: var(--gR-white);
}

.brands-disclaimer-banner div {
	font-size: 12px;
}

@media (max-width: 1000px) {
	.brand-wall-content {
		margin: 10px 13px !important;
	}

	.brand-navbar:not(.is-sticky) {
		margin: 0 13px !important;
	}
}
</style>

<script>
import Navbar from "@/components/navbars/Navbar.vue"
import Banner from "@/components/Banner.vue"
import BrandCard from "@/components/brand/BrandCard.vue"
import HorizontalNavbar from "@/components/common/HorizontalNavbar.vue"

export default {
	name: "BrandWall",
	components: {
		Navbar,
		Banner,
		BrandCard,
		HorizontalNavbar
	},
	data: function () {
		return {
			navbarSticky: false
		}
	},
	computed: {
		brands() {
			//assigned env for dev and staging to 24 for testing and prod to 67 for beverages to show first
			const bevBrandENV = parseInt(
				`${process.env.VUE_APP_BEVERAGE_BRAND}`
			)
			const brands = this.$store.state.brands.filter(
				(brand) => brand.id !== bevBrandENV
			)
			const bevCompany = this.$store.state.brands.filter(
				(brand) => brand.id == bevBrandENV
			)
			if (bevCompany.length > 0) {
				brands.unshift(bevCompany[0])
			}
			return brands
		},
		brandNavbarOptions() {
			return this.brands.map((brand) => {
				return {
					id: brand.id,
					text: brand.name
				}
			})
		},
		brandsAboveTheFold() {
			return this.brands.slice(0, 4)
		},
		brandsBelowTheFold() {
			return this.brands.slice(4, this.brands.length)
		}
	},
	methods: {
		brandSelected(brandOption) {
			this.$router.push({
				path: `/${this.$route.params.slug}/menu`,
				query: { brandId: brandOption.id }
			})
		},
		handleScroll() {
			const brandNavbar = this.$refs.brandNavbar

			if (brandNavbar && brandNavbar.$el) {
				const rect = brandNavbar.$el.getBoundingClientRect()
				this.navbarSticky = rect.top <= 0
			}
		}
	}
}
</script>